"use strict";

var _toConsumableArray = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _taggedTemplateLiteral = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var codegen_1 = require("ajv/dist/compile/codegen");

function getDef() {
  return {
    keyword: "deepRequired",
    type: "object",
    schemaType: "array",
    code: function code(ctx) {
      var schema = ctx.schema,
          data = ctx.data;
      var props = schema.map(function (jp) {
        return (0, codegen_1._)(_templateObject || (_templateObject = _taggedTemplateLiteral(["(", ") === undefined"])), getData(jp));
      });
      ctx.fail((0, codegen_1.or).apply(void 0, _toConsumableArray(props)));

      function getData(jsonPointer) {
        if (jsonPointer === "") throw new Error("empty JSON pointer not allowed");
        var segments = jsonPointer.split("/");
        var x = data;
        var xs = segments.map(function (s, i) {
          return i ? x = (0, codegen_1._)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", "", ""])), x, (0, codegen_1.getProperty)(unescapeJPSegment(s))) : x;
        });
        return (0, codegen_1.and).apply(void 0, _toConsumableArray(xs));
      }
    },
    metaSchema: {
      type: "array",
      items: {
        type: "string",
        format: "json-pointer"
      }
    }
  };
}

exports.default = getDef;

function unescapeJPSegment(s) {
  return s.replace(/~1/g, "/").replace(/~0/g, "~");
}

module.exports = getDef;